'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import frontendService from '../services/FrontendService';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Check if user is authenticated and redirect accordingly
    if (frontendService.isAuthenticated()) {
      router.push('/rooms');
    } else {
      router.push('/login');
    }
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          LiveKit Demo
        </h1>
        <p className="text-gray-600 mb-8">
          Testing LiveKit integration with Phase 2 billing system
        </p>
        <div className="text-sm text-gray-500">
          Redirecting...
        </div>
      </div>
    </div>
  );
}
